/**
 * This is required to ensure IE11+ can work on this webapp,
 * emulating a full ES2015+ environment
 */
import 'isomorphic-fetch'

import React, { Component } from 'react'
import { Auth } from 'aws-amplify'
import LoginPanel from '../components/LoginPanel'

const INITIAL_STATE = {
  isLoading: false,
  email: '',
  password: '',
  passwordResetRequired: false
}

export default class LoginContainer extends Component {

  state = INITIAL_STATE

  validateForm = () => {
    return this.state.email.length && this.state.password.length
  }

  handleChange = event => this.setState({ [event.target.id]: event.target.value })

  handleSubmit = async event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    try {
      const auth = await Auth.signIn(this.state.email, this.state.password)
      if (auth.signInUserSession == null && auth.challengeName === "NEW_PASSWORD_REQUIRED") {
        alert('É necessário trocar a senha')
        this.setState(INITIAL_STATE)
      } else {
        this.props.setAuthenticatedUser(auth.signInUserSession.idToken.payload.email)
      }
      this.setState(INITIAL_STATE)
    } catch (e) {
      this.setState(INITIAL_STATE)
      console.error(e.code);
      console.error(e);
      if (e.code === 'NotAuthorizedException') {
        alert('Senha inválida!')
      } else if(e.code === 'PasswordResetRequiredException') {
        this.setState({        
          passwordResetRequired: true 
        })   
      } else if(e.code === 'UserNotFoundException') {
        alert('Usuário não cadastrado!')
      } else if(e.code === 'UserNotConfirmedException') {
          alert('Por favor confirme o código recebido no email antes.')
      } else {
        alert('Erro inesperado! Contate o Administrador.')
        console.error('erro', e)
      }
    }
  }

  render() {
    return (
      <LoginPanel
        email={this.state.email}
        password={this.state.password}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        validateForm={this.validateForm}
        isLoading={this.state.isLoading}
        passwordResetRequired={this.state.passwordResetRequired}  />
    )
  }
}
